import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default class ThemeChange {
  constructor() {
    this.getDomElements()

    if (!this.dom.triggers.length) return

    gsap.registerPlugin(ScrollTrigger);
    
    this.init()
  }

  init() {
    this.dom.triggers.forEach(trigger => {
      let newTheme = trigger.dataset.theme
      let previousTheme = trigger.dataset.theme == 'dark' ? 'light' : 'dark'

      ScrollTrigger.create({
        trigger: trigger,
        start: "40% 50%",
        onEnter: () => {
          this.dom.body.dataset.theme = newTheme,
          this.dom.body.classList.add('is-transitioning')

          setTimeout(() => {
            this.dom.body.classList.remove('is-transitioning')
          }, 450);
        },
        onLeaveBack: () => {
          this.dom.body.dataset.theme = previousTheme
          this.dom.body.classList.add('is-transitioning')

          setTimeout(() => {
            this.dom.body.classList.remove('is-transitioning')
          }, 450);
        }
      })
    });
  }

  getDomElements() {
    this.dom = {
      'triggers' : document.querySelectorAll('.js-theme-change'),
      'body' : document.querySelector('body'),
    }
  }
}